import { cloud } from './http';
import type {
	SelectraQualificationResponse,
	SelectraPricesResponse,
	SelectraLiveTariffStatus,
	SelectraDetailsResponse,
} from 'src/types/Selectra';

const SELECTRA_BASE = '/v2/users/power-prices/selectra';

const coerceQualificationValue = (field: string, value: unknown): unknown => {
	if (value === null || value === undefined || typeof value === 'number') {
		return value;
	}

	if (field.endsWith('_id') && typeof value === 'string' && /^\d+$/.test(value)) {
		return Number(value);
	}

	return value;
};

const coerceQualificationInputs = (inputs: Record<string, unknown>): Record<string, unknown> =>
	Object.fromEntries(
		Object.entries(inputs).map(([field, value]) => [field, coerceQualificationValue(field, value)]),
	);

/**
 * Stateless wrappers around the Selectra dynamic energy prices API in iotu.
 * Kept free of app state so this layer can be reused by future dashboard widgets.
 */

export const getStoredQualification = async (): Promise<Record<string, unknown>> => {
	return cloud.get(`${SELECTRA_BASE}/qualification`);
};

export const postQualification = async (
	inputs: Record<string, unknown>,
): Promise<SelectraQualificationResponse> => {
	const res = await cloud.post(`${SELECTRA_BASE}/qualification`, coerceQualificationInputs(inputs));
	return res.data;
};

export const deleteQualification = async (): Promise<void> => {
	await cloud.delete(`${SELECTRA_BASE}/qualification`);
};

export const getPrices = async (): Promise<SelectraPricesResponse> => {
	return cloud.get(`${SELECTRA_BASE}/prices`);
};

export const getLiveTariffStatus = async (): Promise<SelectraLiveTariffStatus> => {
	return cloud.get(`${SELECTRA_BASE}/live-tariff`);
};

export const getDetails = async (): Promise<SelectraDetailsResponse> => {
	return cloud.get(`${SELECTRA_BASE}/details`);
};

export const enableLiveTariff = async (): Promise<void> => {
	await cloud.post(`${SELECTRA_BASE}/live-tariff`);
};

export const disableLiveTariff = async (): Promise<void> => {
	await cloud.delete(`${SELECTRA_BASE}/live-tariff`);
};
